<template>
  <v-dialog eager @input="change" value="true" :max-width="width" :persistent="persistent" @keydown.esc="choose(false)">
    <v-card tile>            
      <v-card-title class="alert-title d-flex justify-center" :class="{[`${color}--text`]:true}">        
        {{title}}
      </v-card-title>
      <v-divider class="primary mt-3" width="50%" style="margin:auto;" />
      <v-card-subtitle  v-if="icon.length > 0" class="text-center mb-0 mt-4 pb-0" >
        <v-icon v-text="icon"></v-icon>
      </v-card-subtitle>
      <v-card-text class="body-2 py-6 text-center" v-html="message"/>
      <v-card-actions class="pb-6  px-6">                     
        <v-btn
          v-if="Boolean(buttonFalseText)"
          style="min-width:40%"
          :color="buttonFalseColor"
          :text="buttonFalseFlat"
          @click="choose(false)"
        >
          {{ buttonFalseText }}
        </v-btn>
        <v-spacer />
        <v-btn
          v-if="Boolean(buttonTrueText)"
          style="min-width:40%"
          :color="buttonTrueColor"
          :text="buttonTrueFlat"
          @click="choose(true)"
        >
          {{ buttonTrueText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { VCard, VCardActions, VCardText, VDialog, VIcon, VToolbar, VToolbarTitle, VSpacer, VBtn } from 'vuetify/lib'

export default {
  components: {
    VCard,
    VCardActions,
    VCardText,
    VDialog,
    VIcon,
    VToolbar,
    VToolbarTitle,
    VSpacer,
    VBtn
  },
  props: {
    buttonTrueText: {
      type: String,
      default: 'Yes'
    },
    buttonFalseText: {
      type: String,
      default: 'No'
    },
    buttonTrueColor: {
      type: String,
      default: 'primary'
    },
    buttonFalseColor: {
      type: String,
      default: 'primary'
    },
    buttonFalseFlat: {
      type: Boolean,
      default: false
    },
    buttonTrueFlat: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      required: true
    },
    persistent: Boolean,
    title: {
      type: String
    },
    width: {
      type: Number,
      default: 450
    }
  },
  data () {
    return {
      value: false
    }
  },
  mounted () {
    document.addEventListener('keyup', this.onEnterPressed)
  },
  destroyed () {
    document.removeEventListener('keyup', this.onEnterPressed)
  },
  methods: {
    onEnterPressed (e) {
      if (e.keyCode === 13) {
        e.stopPropagation()
        this.choose(true)
      }
    },
    choose (value) {
      this.$emit('result', value)
      this.value = value
      this.$destroy()
    },
    change (res) {
      this.$destroy()
    }
  }
}
</script>
